import { useEffect, useState } from "react";
import {
  demographicsApi,
  useGetDemographicListingQuery,
  useGetDemographicsQuery,
} from "../../redux/service/demographic_services";
import Consent from "./consent";
import Contact from "./contact";
import EditForm from "./editForm";
import Insurance from "./insurance";
import History from "./history";
import AmendmentRequestUpPop from "./amendmentRequestUpPop";
import { capitalizeFirstLetter, formattedDatePp } from "../../utils/common_lib";
import LoadingBar from "../../components/LoadingBar";
import FullScreenLoader from "../../components/FullScreenLoader";
import {hasActionRights} from "../../userStore";

export const PatientDemographics = (props) => {
  const [locationDetail, setlocationDetail] = useState(false);
  const {
    data,
    refetch: refetchDemographics,
    isLoading,
  } = useGetDemographicsQuery();
  const [loading, setLoading] = useState(false);
  const { data: demographicsMeta } = useGetDemographicListingQuery();
  const [getContacts] = demographicsApi.endpoints.getContacts.useLazyQuery();
  const [getConsents] = demographicsApi.endpoints.getConsents.useLazyQuery();
  const [getInsurances] =
    demographicsApi.endpoints.getInsurances.useLazyQuery();
  const [getHistory] = demographicsApi.endpoints.getHistory.useLazyQuery();
  const [previewData, setPreviewData] = useState(null);
  const content = {
    demographicsData: false,
    insurance: false,
    contact: false,
    consents: false,
    editForm: false,
    history: false,
  };
  const [showContent, setShowContent] = useState({
    ...content,
    demographicsData: true,
  });
  useEffect(() => {
    if (demographicsMeta && data) {
      console.log(
        demographicsMeta,
        data?.data?.demographics?.patient?.default_location,
        "heree"
      );
      const filterLocation = demographicsMeta?.data?.location?.find(
        (v, k) => v?.id == data?.data?.demographics?.patient?.default_location
      );
      setlocationDetail(filterLocation);
    }
  }, [data, demographicsMeta]);
  return (
    <>
      {isLoading && <FullScreenLoader />}
      <AmendmentRequestUpPop
        previewData={previewData}
        setPreviewData={setPreviewData}
        refetchDemographics={refetchDemographics}
      />

      <div className="text-left m-4">
        {data?.data?.demographics?.amendment_request?.status == "Pending" && (
          <div className="bg-green-100 border-green-300 p-3 m-3 text-center">
            Amendment Request Sent! Your demographics will be updated after
            approval from the Practices
          </div>
        )}

        <div className="flex justify-between gap-2  pb-3 mb-3">
          <div>
            <h3 className="text-lg font-bold">
              {data?.data?.demographics?.patient?.full_name}
            </h3>
            <p className="mt-1 text-base">
              {capitalizeFirstLetter(data?.data?.demographics?.patient?.sex)},
              <span className="ms-2">
                {formattedDatePp(
                  data?.data?.demographics?.patient?.DOB,
                  "MM/DD/YYYY"
                )}
              </span>
              <span className="ms-2">
                ({data?.data?.demographics?.patient?.Age})
              </span>
            </p>
          </div>
          <div>
            <button
              className="rounded bg-white px-2 py-1 text-xs font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
              onClick={async () => {
                setLoading(true);
                if (showContent.contact) {
                  await getContacts();
                  setLoading(false);
                } else if (showContent.consents) {
                  await getConsents();
                  setLoading(false);
                } else if (showContent.history) {
                  await getHistory();
                  setLoading(false);
                } else if (showContent.insurance) {
                  await getInsurances();
                  setLoading(false);
                } else {
                  await refetchDemographics();
                  setLoading(false);
                }
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="w-5 h-5"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99"
                />
              </svg>
            </button>
          </div>
        </div>
        {loading && (
          <div className="mb-3 -mx-4">
            <LoadingBar />
          </div>
        )}
        {showContent.demographicsData && (
          <div>
            <div className="flex justify-between gap-2 border-b pb-3 mb-3">
              <div className="flex gap-2 items-center">
                <button
                  onClick={() =>
                    setShowContent({ ...content, insurance: true })
                  }
                  type="button"
                  className="rounded-md bg-blue-600 px-2.5 py-1.5 text-sm font-semibold text-white shadow-sm hover:bg-blue-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
                >
                  Insurances
                </button>
                <button
                  type="button"
                  className="rounded-md bg-blue-600 px-2.5 py-1.5 text-sm font-semibold text-white shadow-sm hover:bg-blue-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
                  onClick={() => setShowContent({ ...content, contact: true })}
                >
                  Contacts
                </button>
                <button
                  type="button"
                  className="rounded-md bg-blue-600 px-2.5 py-1.5 text-sm font-semibold text-white shadow-sm hover:bg-blue-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
                  onClick={() => setShowContent({ ...content, consents: true })}
                >
                  Consent
                </button>
              </div>
              <div className="flex gap-2 items-center">
                {data?.data?.demographics?.amendment_request?.status ==
                "Pending" ? hasActionRights('demographics','add')==1?(
                  <button
                    type="button"
                    className="rounded-md bg-blue-600 px-2.5 py-1.5 text-sm font-semibold text-white shadow-sm hover:bg-blue-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
                    onClick={() =>
                      setPreviewData({
                        ...data?.data?.demographics?.amendment_request,
                        cancelRequest: true,
                      })
                    }
                  >
                    Cancel Request
                  </button>
                ):null : hasActionRights('demographics','add')==1&&(
                  <button
                    type="button"
                    className="rounded-md bg-blue-600 px-2.5 py-1.5 text-sm font-semibold text-white shadow-sm hover:bg-blue-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
                    onClick={() =>
                      setShowContent({ ...content, editForm: true })
                    }
                  >
                    Edit
                  </button>
                )}

                <button
                  onClick={() => setShowContent({ ...content, history: true })}
                  className="rounded bg-white px-2 py-1 text-xs font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="w-6 h-6"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                    />
                  </svg>
                </button>
              </div>
            </div>

            <div className="flex gap-2 mt-3 mb-2">
              <div className="w-1/2">
                <p className="text-sm">
                  <strong>Title:</strong>{" "}
                  {data?.data?.demographics?.patient.title
                    ? data?.data?.demographics?.patient.title
                    : "N/A"}
                </p>
              </div>
              <div className="w-1/2">
                <p className="text-sm">
                  <strong>First Name:</strong>{" "}
                  {data?.data?.demographics?.patient.fname}
                </p>
              </div>
            </div>
            <div className="flex gap-2 mb-3">
              <div className="w-1/2">
                <p className="text-sm">
                  <strong>Middle Name:</strong>{" "}
                  {data?.data?.demographics?.patient.mname
                    ? data?.data?.demographics?.patient.mname
                    : "N/A"}
                </p>
              </div>
              <div className="w-1/2">
                <p className="text-sm">
                  <strong>Last Name:</strong>{" "}
                  {data?.data?.demographics?.patient.lname}
                </p>
              </div>
            </div>
            <div className="flex gap-2 mb-3">
              <div className="w-1/2">
                <p className="text-sm">
                  <strong>Suffix:</strong>{" "}
                  {data?.data?.demographics?.patient.suffix
                    ? data?.data?.demographics?.patient.suffix
                    : "N/A"}
                </p>
              </div>
              <div className="w-1/2">
                <p className="text-sm">
                  <strong>SSN:</strong>{" "}
                  {data?.data?.demographics?.patient.ss
                    ? data?.data?.demographics?.patient.ss
                    : "N/A"}
                </p>
              </div>
            </div>

            <div className="flex gap-2 mt-3 mb-2">
              <div className="w-1/2">
                <p className="text-sm">
                  <strong>Gender:</strong>{" "}
                  {capitalizeFirstLetter(data?.data?.demographics?.patient.sex)}
                </p>
              </div>
              <div className="w-1/2">
                <p className="text-sm">
                  <strong>Gender Identity:</strong>{" "}
                  {data?.data?.demographics?.patient.gender_identity_title
                    ? data?.data?.demographics?.patient.gender_identity_title
                    : "N/A"}
                </p>
              </div>
            </div>
            <div className="flex gap-2 mb-2">
              <div className="w-1/2">
                <p className="text-sm">
                  <strong>Sexual Orientation:</strong>{" "}
                  {data?.data?.demographics?.patient.sexual_orientation_title
                    ? data?.data?.demographics?.patient.sexual_orientation_title
                    : "N/A"}
                </p>
              </div>
              <div className="w-1/2">
                <p className="text-sm">
                  <strong>Marital Status:</strong>{" "}
                  {data?.data?.demographics?.patient.marital_status_title
                    ? data?.data?.demographics?.patient.marital_status_title
                    : "N/A"}
                </p>
              </div>
            </div>

            <div className="flex gap-2 mb-2">
              <div className="w-1/2">
                <p className="text-sm">
                  <strong>DOB:</strong>{" "}
                  {formattedDatePp(
                    data?.data?.demographics?.patient.DOB,
                    "MM/DD/YYYY"
                  )}
                </p>
              </div>
              <div className="w-1/2">
                <p className="text-sm">
                  <strong>Preferred Language:</strong>{" "}
                  {data?.data?.demographics?.patient.language_title
                    ? data?.data?.demographics?.patient.language_title
                    : "N/A"}
                </p>
              </div>
            </div>

            <div className="flex gap-2 mb-2">
              <div className="w-1/2">
                <p className="text-sm">
                  <strong>Chart Number:</strong>{" "}
                  {data?.data?.demographics?.patient.cid
                    ? data?.data?.demographics?.patient.cid
                    : "N/A"}
                </p>
              </div>
              <div className="w-1/2">
                <p className="text-sm">
                  <strong>MRN:</strong>{" "}
                  {data?.data?.demographics?.patient.mrn
                    ? data?.data?.demographics?.patient.mrn
                    : "N/A"}
                </p>
              </div>
            </div>

            <div className="flex gap-2 mb-2">
              <div className="w-1/2">
                <p className="text-sm">
                  <strong>Race:</strong>{" "}
                  {data?.data?.demographics?.patient.race_title
                    ? data?.data?.demographics?.patient.race_title
                    : "N/A"}
                </p>
              </div>
              <div className="w-1/2">
                <p className="text-sm">
                  <strong>Ethnicity:</strong>{" "}
                  {data?.data?.demographics?.patient.ethnicity_title
                    ? data?.data?.demographics?.patient.ethnicity_title
                    : "N/A"}
                </p>
              </div>
            </div>

            <div className="flex gap-2 mb-2">
              <div className="w-1/2">
                <p className="text-sm">
                  <strong>Address 1:</strong>{" "}
                  {data?.data?.demographics?.patient.street
                    ? data?.data?.demographics?.patient.street
                    : "N/A"}
                </p>
              </div>
              <div className="w-1/2">
                <p className="text-sm">
                  <strong>Address 2:</strong>{" "}
                  {data?.data?.demographics?.patient.street2
                    ? data?.data?.demographics?.patient.street2
                    : "N/A"}
                </p>
              </div>
            </div>
             {locationDetail?.is_fqhc && 

               <div className="flex gap-2 mb-2">
                 <div className="w-1/2">
                   <p className="text-sm">
                     <strong>Veteran:</strong>{" "}
                     {data?.data?.demographics?.patient.veteran ? "Yes" : "No"}
                   </p>
                 </div>
               </div>
             }
            <div className="flex gap-2 mb-2">
              <div className="w-1/2">
                <p className="text-sm">
                  <strong>City:</strong>{" "}
                  {data?.data?.demographics?.patient.city}
                </p>
              </div>
              <div className="w-1/2">
                <p className="text-sm">
                  <strong>State:</strong>{" "}
                  {data?.data?.demographics?.patient.state
                    ? data?.data?.demographics?.patient.state
                    : "N/A"}
                </p>
              </div>
            </div>

            <div className="flex gap-2 mb-2">
              <div className="w-1/2">
                <p className="text-sm">
                  <strong>Zipcode:</strong>{" "}
                  {data?.data?.demographics?.patient.postal_code}
                </p>
              </div>
              <div className="w-1/2">
                <p className="text-sm">
                  <strong>County:</strong>{" "}
                  {data?.data?.demographics?.patient.county
                    ? data?.data?.demographics?.patient.county
                    : "N/A"}
                </p>
              </div>
            </div>

            <div className="flex gap-2 mb-2">
              <div className="w-1/2">
                <p className="text-sm">
                  <strong>Home Phone:</strong>{" "}
                  {data?.data?.demographics?.patient.phone_home
                    ? data?.data?.demographics?.patient.phone_home
                    : "N/A"}
                </p>
              </div>
              <div className="w-1/2">
                <p className="text-sm">
                  <strong>Work Phone:</strong>{" "}
                  {data?.data?.demographics?.patient.phone_biz
                    ? data?.data?.demographics?.patient.phone_biz
                    : "N/A"}
                </p>
              </div>
            </div>

            <div className="flex gap-2 mb-2">
              <div className="w-1/2">
                <p className="text-sm">
                  <strong>Mobile Number:</strong>{" "}
                  {data?.data?.demographics?.patient.phone_cell
                    ? data?.data?.demographics?.patient.phone_cell
                    : "N/A"}
                </p>
              </div>
              <div className="w-1/2">
                <p className="text-sm">
                  <strong>Fax:</strong>{" "}
                  {data?.data?.demographics?.patient.fax
                    ? data?.data?.demographics?.patient.fax
                    : "N/A"}
                </p>
              </div>
            </div>

            <div className="flex gap-2 mb-2">
              <div className="w-1/2">
                <p className="text-sm">
                  <strong>Email:</strong>{" "}
                  {data?.data?.demographics?.patient.email
                    ? data?.data?.demographics?.patient.email
                    : "N/A"}
                </p>
              </div>
            </div>

            <div className="flex gap-2 mb-2">
              <div className="w-1/2">
                <p className="text-sm">
                  <strong>Mother's Maiden First Name:</strong>{" "}
                  {data?.data?.demographics?.patient.mothersname
                    ? data?.data?.demographics?.patient.mothersname
                    : "N/A"}
                </p>
              </div>
              <div className="w-1/2">
                <p className="text-sm">
                  <strong>Mother's Maiden Last Name:</strong>{" "}
                  {data?.data?.demographics?.patient.mother_lname
                    ? data?.data?.demographics?.patient.mother_lname
                    : "N/A"}
                </p>
              </div>
            </div>
          </div>
        )}

        {showContent?.insurance && (
          <Insurance
            crossHandler={() =>
              setShowContent({ ...content, demographicsData: true })
            }
          />
        )}
        {showContent?.consents && (
          <Consent
            crossHandler={() =>
              setShowContent({ ...content, demographicsData: true })
            }
          />
        )}
        {showContent?.contact && (
          <Contact
            crossHandler={() =>
              setShowContent({ ...content, demographicsData: true })
            }
          />
        )}
        {showContent?.editForm && (
          <EditForm
            locationDetail={locationDetail}
            setlocationDetail={setlocationDetail}
            crossHandler={() =>
              setShowContent({ ...content, demographicsData: true })
            }
          />
        )}
        {showContent?.history && (
          <History
            crossHandler={() =>
              setShowContent({ ...content, demographicsData: true })
            }
          />
        )}
      </div>
    </>
  );
};
